<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title1"
      :visible.sync="dialogVisible"
      width="350px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="90px"
        :label-position="labelPosition"
      >
        <el-form-item label="回执信息:" prop="receipt">
          <el-input
            v-model="params.receipt"
            size="small"
            type="textarea"
            :rows="4"
            placeholder="回执信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title1: "",
      flag: false,
      id: "",
      // 审核通过/拒绝 表单数据
      params: {
        receipt: "",
        type:'',
        nudeChatId: "",
      },

      // 表单验证规则
      rules: {
        receipt: [
          { required: true, message: "请填写回执信息", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
            this.passReview();
        } else {
          return false;
        }
      });
    },
    // 通过
    passReview() {
      let params = Object.assign({}, this.params, {
        id: this.id,
        processingStatus:1
      });
      API.operateFeedback(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$emit("handlerAgentList");
          } else {
            if (res.tip) {
              this.$message.error(res.tip);
            } else {
              this.$message.error("操作失败");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },


    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        receipt: "",
        type:'',
        nudeChatId: "",
      };
      this.id = "";
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open( data) {
      this.dialogVisible = true;
      this.id = data.id;
      this.title1 = "回复操作";
      this.params.receipt = data.receipt ? data.receipt : '该信息已经下架！请联系官方客服获取新的裸聊信息！';
      this.params.type = 1;
      this.params.nudeChatId = data.nudeChatId;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .item-box {
    margin-left: 28px;
    width: 100%;
    display: flex;
    .item1 {
      flex: 1;
      .upload {
        position: relative;
        top: 35px;
        left: -90px;
      }
    }
    .item2 {
      flex: 3;
      width: 250px;
      position: relative;
      top: 0px;
      left: -60px;
    }
  }
}
</style>
